import { message } from 'antd'

import {
    createDfmFeedbackMessageMutation,
    messageManagemenPageDfmFeedbackMessages,
    editDfmFeedbackMessageMutation,
} from '~/apps/consumer/pages/Quotes/Admin/DfmMessageManagementPage/query'
import {
    HIDE_DFM_MESSAGE_CREATE_MODAL,
    SET_DFM_MESSAGE_CREATE_FAILURE,
    SET_DFM_MESSAGE_CREATE_SUCCESS,
    SET_LOADING_DFM_MESSAGE_CREATE,
    SET_LOADING_DFM_MESSAGE_EDIT,
    SET_DFM_MESSAGE_EDIT_SUCCESS,
    SET_DFM_MESSAGE_EDIT_FAILURE,
    SHOW_DFM_MESSAGE_CREATE_MODAL,
    SHOW_DFM_MESSAGE_EDIT_MODAL,
    HIDE_DFM_MESSAGE_EDIT_MODAL,
} from '~/redux-modules/dfm-messages/constant'
import { types as GraphqlTypes } from '~/redux-modules/graphql'
import {
    DfmFeedbackMessageType,
    DfmFeedbackSeverity,
} from '~/__generated__/globalTypes'
import { messageManagemenPageDfmFeedbackMessages_dfmFeedbackMessages } from '~/apps/consumer/pages/Quotes/Admin/DfmMessageManagementPage/__generated__/messageManagemenPageDfmFeedbackMessages'

export const showDFMMessageCreateModal = () => ({
    type: SHOW_DFM_MESSAGE_CREATE_MODAL,
    payload: null,
})

export const hideDFMMessageCreateModal = () => ({
    type: HIDE_DFM_MESSAGE_CREATE_MODAL,
    payload: null,
})

export const setLoadingForDFMMesaageCreate = () => ({
    type: SET_LOADING_DFM_MESSAGE_CREATE,
    payload: null,
})

export const setLoadingForDFMMesaageEdit = () => ({
    type: SET_LOADING_DFM_MESSAGE_EDIT,
    payload: null,
})

export const setDFMMessageCreateSuccess = (
    createdMessage: messageManagemenPageDfmFeedbackMessages_dfmFeedbackMessages,
) => ({
    type: SET_DFM_MESSAGE_CREATE_SUCCESS,
    payload: createdMessage,
})

export const setDFMMessageEditSuccess = (
    EditedMessage: messageManagemenPageDfmFeedbackMessages_dfmFeedbackMessages,
) => ({
    type: SET_DFM_MESSAGE_EDIT_SUCCESS,
    payload: EditedMessage,
})

export const setDFMMessageCreateFailure = (error: string) => ({
    type: SET_DFM_MESSAGE_CREATE_FAILURE,
    payload: error,
})

export const setDFMMessageEditFailure = (error: string) => ({
    type: SET_DFM_MESSAGE_EDIT_FAILURE,
    payload: error,
})

export const showDFMMessagEditModal = (
    payload: messageManagemenPageDfmFeedbackMessages_dfmFeedbackMessages,
) => ({
    type: SHOW_DFM_MESSAGE_EDIT_MODAL,
    payload,
})

export const hideDFMMessageEditModal = () => ({
    type: HIDE_DFM_MESSAGE_EDIT_MODAL,
    payload: null,
})

export const createDfmFeedbackMessage = (payload: {
    code: string
    type: DfmFeedbackMessageType
    severity: DfmFeedbackSeverity
    platformProcessId: string
    title: string
    message: string
    link: string
    topicId: string
    disabled: boolean
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setLoadingForDFMMesaageCreate())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.mutate({
                mutation: createDfmFeedbackMessageMutation,
                variables: {
                    ...payload,
                },
                refetchQueries: [
                    { query: messageManagemenPageDfmFeedbackMessages },
                ],
            })

            message.success('DFM message created successfully')

            dispatch(setDFMMessageCreateSuccess(res.data))
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setDFMMessageCreateFailure(errorMessage))
        }
    }
}

export const editDfmFeedbackMessage = (payload: {
    id: string
    severity: DfmFeedbackSeverity
    title: string
    message: string
    link: string
    platformProcessId: string
    disabled: boolean
}) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore: until we have a type for dispatch and getState
    return async (dispatch, getState) => {
        try {
            dispatch(setLoadingForDFMMesaageEdit())
            const apolloClient: GraphqlTypes.ApolloClientType =
                getState().graphql.apolloClient
            const res = await apolloClient.mutate({
                mutation: editDfmFeedbackMessageMutation,
                variables: {
                    ...payload,
                },
                refetchQueries: [
                    { query: messageManagemenPageDfmFeedbackMessages },
                ],
            })

            message.success('DFM message updated successfully')

            dispatch(setDFMMessageEditSuccess(res.data))
        } catch (error) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const errorMessage: string = (error as any).message

            message.error(errorMessage)
            dispatch(setDFMMessageEditFailure(errorMessage))
        }
    }
}
